/**
 * @GENERATED from Figma node 3638:51864
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleMeetDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#188038"
      d="m13.5 12 2.133 2.438L18.5 16.25l.5-4.234-.5-4.16-2.922 1.61z"
    />
    <path
      fill="#1967D2"
      d="M1.125 15.875V19.5a1.5 1.5 0 0 0 1.5 1.5H6.25L7 18.26l-.75-2.385-2.487-.75z"
    />
    <path
      fill="#EA4335"
      d="M6.25 3 1.125 8.125l2.638.75 2.487-.75.737-2.354z"
    />
    <path fill="#4285F4" d="M6.25 8.125H1.125v7.75H6.25z" />
    <path
      fill="#34A853"
      d="M21.774 5.17 18.5 7.856v8.394l3.288 2.796A.75.75 0 0 0 23 18.455V5.75a.75.75 0 0 0-1.226-.58M13.5 12v3.875H6.25V21H17a1.5 1.5 0 0 0 1.5-1.5v-3.25z"
    />
    <path
      fill="#FBBC04"
      d="M17 3H6.25v5.125h7.25V12l5-4.144V4.5A1.5 1.5 0 0 0 17 3"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleMeetDark);
export { ForwardRef as GoogleMeetDark };
